import { createAction, props } from "@ngrx/store";
import { ScreenWidth } from "../models/screenWidth.model";
import { IUser } from "../models/IUser.model";
import { UserDetail } from "../../models/UserDetail.model";

export interface SetContainerTypeProps {
  containerType: 'normal' | 'fluid'
}

export const setContainerTypeAction = createAction(
  'SET_CONTAINER_TYPE',
  props<SetContainerTypeProps>()
);

export interface SetScreenWidthProps {
  screenWidth?: ScreenWidth;
}

export const setScreenWidthAction = createAction(
  'SET_SCREEN_WIDTH',
  props<SetScreenWidthProps>()
);

export interface ShowLoadingMaskProps {
  showLoadingMask?: boolean;
}

export const showLoadingMaskAction = createAction(
  'SHOW_LOADING_MASK',
  props<ShowLoadingMaskProps>()
);

export interface SetUserProps {
  user?: IUser;
}

export interface SetPermissionsProps {
  permissions?: string[];
}

export const setPermissionsAction = createAction(
  'SET_PERMISSIONS',
  props<SetPermissionsProps>()
);

export interface SetUserDetailProps {
  userDetail?: UserDetail;
}

export const setUserDetailAction = createAction(
  'SET_USER_DETAIL',
  props<SetUserDetailProps>()
);
